import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { colors } from "@material-ui/core";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import { useHeader } from "../../bill-template02/style";
import { getcolor } from "./UnderHeaderCom";

function HeaderCom(props) {

    const { found, sta, inv, locInv,premiApp } = props;
    const classHeader = useHeader();
    const clas = useInvAF();
    const styfNum = { fontWeight: "bold", textAlign: "center", color: colors.red[500], direction: "ltr" };
    const styfOther = { fontWeight: "bold", textAlign: "center", direction: "ltr" };
    const styleSecond = { fontWeight: "bold", textAlign: "left", direction: "ltr", paddingLeft: "0.3rem" };
    const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1rem" };
    const styleNameE = { fontWeight: "bold", textAlign: "left", fontSize: "1rem" };
    const invColors = sta?.StngIA?.colors;
    const secondColor = getcolor(invColors);

    return (
        <Grid item container
            justifyContent="center"
        >
            <Grid

                container
                item xs={12}
                style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", paddingTop: "0.9rem", marginLeft: "0cm", direction: "rtl" }}
            >
                <Grid container item xs={6} >
                    <Grid item xs={12}>
                        <div style={styleNameA}>{found.Disc1_header_ar}</div>
                        <div style={styleNameA}>{found.Disc1_header_en}</div>
                        <br />
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={6} className={classHeader.leftHeaderen}>
                            <div style={styfNum}>{sta.tot.id}</div>
                            <div style={styfOther}>{moment(sta.tot.date).format("YYYY/MM/DD")}</div>
                            <div style={styfOther}>{moment(sta.tot.Due_date).format("YYYY/MM/DD")}</div>{" "}
                            <div style={styfOther}>{locInv.ProcTypeInvProc === "03" ? "QUOTATION" : locInv.ProcTypeInvProc === "04" ? "PURCHASE ORDER" :
                                premiApp.billTemplate === 26 ? locInv.invNEn
                                    : inv.pay_type == 1 ? "نقدية" + "/Cash" : inv.pay_type == -1 ? "آجلة" + "/Credit" :
                                        "شبكة " + "/Network"}</div>{" "}
                        </Grid>
                        <Grid item xs={6} className={classHeader.leftHeaderen}>
                            <div style={styleSecond}>{"Invoice Number"}{"/"}{"رقم الفاتورة"}</div>
                            <div style={styleSecond}>{"Invoice Date"}{"/"}{"تاريخ الفاتورة"}</div>
                            <div style={styleSecond}>{"Due Date"}{"/"}{"تاريخ الاستحقاق"}</div>{" "}
                            <div style={styleSecond}>{locInv.ProcTypeInvProc === "03" || locInv.ProcTypeInvProc === "04" ? "Invoice Type" :
                                premiApp.billTemplate === 26 ? "Invoice Type" : "Payment Method"}{"/"}
                                {locInv.ProcTypeInvProc === "03" || locInv.ProcTypeInvProc === "04" ? "نوع الفاتورة" :
                                    premiApp.billTemplate === 26 ? "نوع الفاتورة" : "طريقة الدفع"}</div>{" "}
                        </Grid>
                    </Grid>


                </Grid>

                <Grid container item xs={6} >
                    <Grid container item xs={7} justifyContent="center">
                        <Grid item xs={12} >
                            <div>
                                <ButtonBase>
                                    {" "}
                                    <img
                                        src={`data:image/jpeg;base64,${found.Logo}`}
                                        className={clas.Hedlogo}
                                        alt={found.nameA}
                                    />{" "}
                                </ButtonBase>
                            </div>
                        </Grid>
                        {inv.tax > 0 && (
                            <Grid item xs={12} style={{ backgroundColor: secondColor, textAlign: "center" }}>
                                { locInv.ProcTypeInvProc === "03"|| locInv.ProcTypeInvProc === "04"?locInv.invN:  sta.tot.tax_no_cust === ""
                                    ? "فاتورة ضريبية مبسطة" + " " : "فاتورة ضريبية"}
                                <br />
                                { locInv.ProcTypeInvProc === "03"?"QUOTATION": locInv.ProcTypeInvProc === "04"?"PURCHASE ORDER" :
                                  sta.tot.tax_no_cust === ""
                                    ? "Simplified Tax Invoice" : "Tax Invoice"}
                            </Grid>
                        )}


                    </Grid>
                    <Grid container item xs={5} justifyContent="center" >
                        <div style={styleNameA}>{ }</div>
                        {inv.tax > 0 &&  locInv.ProcTypeInvProc !== "03" &&  locInv.ProcTypeInvProc !== "04" &&  (
                            <Grid item xs={12} justifyContent="bottom">

                                {(locInv?.Step_inv2 && inv?.ZatcaQR) ? (
                                    <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                                        {
                                            <QRCodeCanvas value={inv?.ZatcaQR} />
                                        }

                                    </ButtonBase>
                                )
                                    : (
                                        <ButtonBase
                                            style={{ textAlign: "center", paddingTop: "1rem", paddingRight: "0.5rem" }}
                                        >
                                            {
                                                <img
                                                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                                                    style={{ height: 130, width: 130, margin: 0, padding: 0 }}
                                                    alt={found.nameA}
                                                />
                                            }
                                        </ButtonBase>
                                    )}

                            </Grid>
                        )}
                    </Grid>
                </Grid>


            </Grid>
        </Grid>
    );
}
export default HeaderCom;